const contactForm = (editor) => {

    editor.BlockManager.add('contactForm', {
        category: 'Forms ',
        label: `
                    <svg  width="1.4vw" height="1.4vw" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path class="gjs-block-svg-path" d="M22,5.5 C22,5.2 21.5,5 20.75,5 L3.25,5 C2.5,5 2,5.2 2,5.5 L2,8.5 C2,8.8 2.5,9 3.25,9 L20.75,9 C21.5,9 22,8.8 22,8.5 L22,5.5 Z M21,8 L3,8 L3,6 L21,6 L21,8 Z" fill-rule="nonzero"></path>
                      <path class="gjs-block-svg-path" d="M22,10.5 C22,10.2 21.5,10 20.75,10 L3.25,10 C2.5,10 2,10.2 2,10.5 L2,13.5 C2,13.8 2.5,14 3.25,14 L20.75,14 C21.5,14 22,13.8 22,13.5 L22,10.5 Z M21,13 L3,13 L3,11 L21,11 L21,13 Z" fill-rule="nonzero"></path>
                      <rect class="gjs-block-svg-path" x="2" y="15" width="10" height="3" rx="0.5"></rect>
                    </svg>
                    <div class='gjs-fontFamily gjs-block-label'>Contact Form</div>
                  `,
        attributes: {},
        content: `
        <div class="col-10 bg-light mx-auto my-4 px-4 rounded shadow">
          <div class="row">
            <div class="col-lg-5 my-4">
              <iframe
                src="https://maps.google.com/maps?&q=Athens&z=10&t=q&output=embed"
                class="h-100 w-100" frameborder="0"></iframe>
            </div>

            <div class="col-lg-7">
              <h3 class="py-3">Contact us</h3>
              <form>
                <div class="row">
                  <div class="col-md-9">
                    <div class="row mb-4">
                      <div class="col-md-6 mb-4 mb-md-0">
                        <div class="form-outline">
                          <label class="form-label fw-bolder" for="form3Example1">First name</label>
                          <input type="text" id="form3Example1" placeholder="First Name" class="form-control" />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-outline">
                          <label class="form-label fw-bolder" for="form3Example2">Email Address</label>
                          <input type="email" id="form3Example2" placeholder="Email Address" class="form-control" />
                        </div>
                      </div>
                    </div>
                    <div class="form-outline mb-4">
                      <label class="form-label fw-bolder" for="form3Example3">Subject</label>
                      <input type="text" id="form3Example3" placeholder="Subject" class="form-control" />
                    </div>
                    <div class="form-outline mb-4">
                      <label class="form-label fw-bolder" for="form4Example3">Message</label>
                      <textarea class="form-control" id="form4Example3" placeholder="Message" rows="4"></textarea>
                    </div>
                    <div class="text-center text-md-start">
                      <button type="submit" class="btn btn-primary shadow mb-5">
                        Send
                      </button>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <ul class="list-unstyled">
                      <li>
                        <i class="bi-geo text-primary"></i>
                        <p><small>New York, NY 10012, USA</small></p>
                      </li>
                      <li>
                        <i class="bi-telephone  text-primary"></i>
                        <p><small>+ 01 234 567 89</small></p>
                      </li>
                      <li>
                        <i class="bi-envelope  text-primary"></i>
                        <p><small>contact@gmail.com</small></p>
                      </li>
                    </ul>
                  </div>
                </div>
              </form>

            </div>
          </div>


        </div>
        `
    })
};

export default contactForm;